import React from "react";
import { classNames } from "Utils/utils";
import { VERTEX360_COPILOT_MODULE_TABS } from "../constants/vertex360CopilotConstants";

const ModulePromptTabs = ({ activeTabId, onTabChange }) => (
  <div
    className="copilot-module-tabs"
    role="tablist"
    aria-label="Browse suggested questions"
  >
    {VERTEX360_COPILOT_MODULE_TABS.map((tab) => {
      const isActive = tab.id === activeTabId;

      return (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={isActive}
          title={tab.label}
          onClick={() => onTabChange(tab.id)}
          className={classNames(
            "copilot-module-tab",
            isActive && "copilot-module-tab--active"
          )}
        >
          <span className="copilot-module-tab__label">{tab.label}</span>
        </button>
      );
    })}
  </div>
);

export default ModulePromptTabs;
